import * as React from 'react';

import { HeadsType, RowPropsType, RowType } from './index';

const Row = <THeadsType extends HeadsType, TRowType extends RowType>({ data, pinned, selected, headers, 
  hasScroll, selectorScope, excluded, hasNotes, rowRef, graphRowRef , pinnedGraphTop, pinnedMainTop  }: RowPropsType<THeadsType, TRowType>) => {
  const { columns, childrenBelow, childrenOver, style } = data;
  /** UPDATE PINNED ROWS STYLE */
    const pinnedMainStyle = pinned
    ? { position: 'sticky' as const, top: pinnedMainTop, zIndex: 250, ...style }
    : style;

  const pinnedGraphStyle = pinned
    ? { position: 'sticky' as const, top: pinnedGraphTop, zIndex: 250 }
    : undefined;
  return (
    <>
      {childrenOver && (
        <tr className="tr-distance-graph-div">
          <td
            className={`t-ll OGCY-fixed-horizontal td-distance-graph-div ${selectorScope} ${(pinned ? 'OGCY-fixed-vertical' : 'OGCY-no-fixed-vertical')}`}
          >
            {childrenOver}
          </td>
        </tr>
      )}
      <tr ref={rowRef} style={pinnedMainStyle}>
        {columns.map((col, index) => (
          <td
            className={
              selectorScope + ' ' +
              (col.class ? col.class : '') +
              (excluded? ' excluded-player' : '') + 
              ((pinned || selected) ? ' pinned-player' : '') +
              ((pinned || selected) && index < 2 ? ' pinned-player-01' : '') +
             ' OGCY-no-fixed-vertical' +
              (headers[index].isColumnFixedY ? ' OGCY-fixed-horizontal' : ' OGCY-no-fixed-horizontal') +
              (headers[index].rightShadow ? ' nvd-custom-table-tr-td-right-shadow' : '')
            }
            onClick={col.onClick}
            key={index}
            id={col.id}
            style={{
              borderRight: (hasScroll && (index === columns.length - 1)) ? 'none' : undefined,
              textAlign: (headers[index].style || {}).textAlign,
              width: (hasScroll && (index === columns.length - 1)) ?
                'calc(' + ((headers[index].style || {}).width) + ' - 4px)' :
                (headers[index].style || {}).width,
              justifyContent: (headers[index].style || {}).textAlign === 'right' ? 'flex-end' : undefined,
              ...col.style
            }}
            colSpan={col.colSpan}
            title={col.title as string}
          >
            {headers[index].isCheckboxCell ? (
              <div
                className="styled-checkbox-label-checked"
                style={{ background: selected ? '#007ABA' : undefined }}
              />
            ) : col.print ? col.print(col.content) : col.content}
          </td>
        ))}
      </tr>
      {childrenBelow && (
        <tr ref={graphRowRef} className="tr-distance-graph-div" style={pinnedGraphStyle}>
          <td
            style={{
              padding: 0,
              height: '40px',
              width: headers[1].content === "EX." ?  `calc(${headers.length !== 23 ? '1px + ' : ''}${(headers[0].style && headers[0].style.width)} +
              ${(headers[1].style && headers[1].style.width)} +
              ${(headers[2].style && headers[2].style.width)} +
              ${(headers[3].style && headers[3].style.width)} +
              ${(headers[4].style && headers[4].style.width)} +
              ${(headers[5].style && headers[5].style.width)})`
              :
              hasNotes || headers[2].content === ''?
              `calc(${headers.length !== 21 ? '1px + ' : ''}${(headers[0].style && headers[0].style.width)} +
              ${(headers[1].style && headers[1].style.width)} +
              ${(headers[2].style && headers[2].style.width)} +
              ${(headers[3].style && headers[3].style.width)} + 
              ${(headers[4].style && headers[4].style.width)} )`
              
              :
               `calc(${headers.length !== 21 ? '1px + ' : ''}${(headers[0].style && headers[0].style.width)} +
               ${(headers[1].style && headers[1].style.width)} +
               ${(headers[2].style && headers[2].style.width)} +
               ${(headers[3].style && headers[3].style.width)} )`        

                        }}
            className={
              't-ll ' + selectorScope +
              ((headers[0] && headers[0].isColumnFixedY) ? ' OGCY-fixed-horizontal' : ' OGCY-no-fixed-horizontal') +
              ((headers[3] && headers[3].rightShadow) ? ' nvd-custom-table-tr-td-right-shadow' : '') +
               ' OGCY-no-fixed-vertical' 
            }
          />
           <td
            className={(headers.length !== 21 ? 't-ll ' : '') + selectorScope + ' OGCY-fixed-horizontal td-distance-graph-div OGCY-no-fixed-vertical'}
          >
            {childrenBelow}
          </td>
        </tr>
      )}
    </>
  );
};

export default React.memo(Row);
